<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Claims by Condition - {{ this.condition }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="pb-0">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting claims.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else-if="this.requestError == false && this.loading != true && claims.length > 0">
          <v-col class="py-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="mb-1"
            ></v-text-field>
          </v-col>
          <v-data-table
            :headers="headers"
            :items="claims"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, -1],
            }"
            :items-per-page="10"
            show-expand
            single-expand
            item-key="CLAIM_ID"
            loading-text="Loading data..."
            class="elevation-0 pb-0 col-12"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="px-0">
                <SpecCodes :insurance="insurance" :claimID="item.CLAIM_ID" />
              </td>
            </template>

            <template v-slot:item.AMOUNT_DEC="{ item }">
              <span>{{ item.AMOUNT }}</span>
            </template>
          </v-data-table>
        </v-row>
        <v-row v-else-if="this.requestError == false && this.loading != true && claims.length == 0">
          <v-col>
            <v-alert type="info">No claims found.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="text-center py-3">
            <v-progress-circular
              indeterminate
              color="secondary"
              :size="50"
              :width="3"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import SpecCodes from '../utilizationComponents/SpecCodes.vue';

export default {
  name: 'ClaimsByCondition',
  props: ['value', 'insurance', 'patient', 'condition', 'conditionType'],
  components: {
    SpecCodes,
  },
  data() {
    return {
      dialog: false,
      loading: true,
      requestError: false,
      search: '',
      headers: [],
      claims: [],
    };
  },
  mounted() {
    this.getHeaders();
  },
  methods: {
    async getClaimsByCondition() {
      this.loading = true;
      this.requestError = false;
      this.claims = [];

      const url = `/api/patient/conditions/claims/${this.condition}/${this.conditionType}/${this.insurance}/${this.patient}`;
      axios
        .get(url)
        .then((response) => {
          this.claims = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.requestError = true;
          this.loading = false;
        });
    },
    async getHeaders() {
      this.headers = [
        { text: 'Claim Number', value: 'CLAIM_ID' },
        { text: 'PCP', value: 'PCP_NAME' },
        { text: 'Servicer Name', value: 'SERVICER_NAME' },
        { text: 'Patient Name', value: 'MEMBER_NAME' },
        // { text: 'DOB', value: 'BIRTH_DATE' },
        { text: 'Start Date', value: 'START_DATE' },
        { text: 'End Date', value: 'END_DATE' },
        { text: 'Amount', value: 'AMOUNT_DEC' },
      ];
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async condition() {
      if (
        this.value == true &&
        this.condition != null &&
        this.condition != 0 &&
        this.condition != ''
      ) {
        this.getClaimsByCondition();
      }
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
